module.exports = __webpack_public_path__ + "img/logo.3a7c8281.svg";